export enum Availability {
    Unknown,
    OrderItem,
    InsufficientStock
}

export class AvailabilityMessage {
    public title: string;
    public text: string;
    public availability: Availability

    constructor(
        title: string,
        text: string,
        availability?: Availability
    ) {
        this.title = title;
        this.text = text;
        this.availability = availability ?? Availability.Unknown
    }
}